import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3058e7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prompt-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prompt-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 640 640",
    fill: "#faad14"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M240 160L240 224L400 224L400 160C400 115.8 364.2 80 320 80C275.8 80 240 115.8 240 160zM192 224L192 160C192 89.3 249.3 32 320 32C390.7 32 448 89.3 448 160L448 224C483.3 224 512 252.7 512 288L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 288C128 252.7 156.7 224 192 224zM400 272L240 272L240 272L192 272L192 272C183.2 272 176 279.2 176 288L176 512C176 520.8 183.2 528 192 528L448 528C456.8 528 464 520.8 464 512L464 288C464 279.2 456.8 272 448 272L448 272L400 272L400 272zM280 300C291 300 300 309 300 320L300 340L340 340L340 320C340 309 349 300 360 300C371 300 380 309 380 320L380 340L400 340C411 340 420 349 420 360C420 371 411 380 400 380L380 380L380 420L400 420C411 420 420 429 420 440C420 451 411 460 400 460L380 460L380 480C380 491 371 500 360 500C349 500 340 491 340 480L340 460L300 460L300 480C300 491 291 500 280 500C269 500 260 491 260 480L260 460L240 460C229 460 220 451 220 440C220 429 229 420 240 420L260 420L260 380L240 380C229 380 220 371 220 360C220 349 229 340 240 340L260 340L260 320C260 309 269 300 280 300zM300 380L300 420L340 420L340 380L300 380z" })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "prompt-title" }, "2단계 인증 설정 안내", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "prompt-message" }, [
  /*#__PURE__*/_createTextVNode(" 고객사의 민감 정보를 다루는 페이지에서는 2단계 인증을 적극 권장하고 있습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2단계 인증을 설정하시겠어요? ")
], -1))
const _hoisted_5 = { class: "prompt-buttons" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dismiss-sub" }, "(오늘 하루동안 뜨지 않게 하기)", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    open: _ctx.visible,
    footer: null,
    closable: false,
    "mask-closable": false,
    centered: "",
    width: "460px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "large",
            block: "",
            onClick: _ctx.handleGoSetup
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 설정하러가기 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            size: "large",
            block: "",
            onClick: _ctx.handleDismiss
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 다음에 하기 "),
              _hoisted_6
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "link",
            block: "",
            onClick: _ctx.handleSnooze
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 일주일 뒤에 다시 알리기 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}